import {toDigits} from "./toDigits";

export const shortFormat : Date = (date: Date) => {
    const day = toDigits(date.getDate(), 2);
    const month = toDigits(date.getMonth() + 1, 2);
    const year = toDigits(date.getFullYear(), 2);
    return day + '.' + month + '.' + year;
};
